import selectProp from './selectProp';

export default (_: any, props: any) => selectProp(props, 'id') as string | undefined;
